import { render, staticRenderFns } from "./regionStage.vue?vue&type=template&id=792f1fc6&scoped=true"
import script from "./regionStage.vue?vue&type=script&lang=js"
export * from "./regionStage.vue?vue&type=script&lang=js"
import style0 from "./regionStage.vue?vue&type=style&index=0&id=792f1fc6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792f1fc6",
  null
  
)

export default component.exports